// src/hooks/usePaidPlacement.js
//
// v1, deliberately simple: one document per day in a `paidPlacements`
// collection, doc ID = the date string (e.g. "2026-09-16"). You assign
// it manually for now (Firebase console, or a two-line admin script) —
// no self-serve checkout yet. Build that once creators are actually
// asking to pay for it, not before.
//
// Schema:
//   paidPlacements/{YYYY-MM-DD}
//     { itemType: "drop" | "creator", itemId: string,
//       purchasedAt: Timestamp, price: number, status: "active" }

import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

function todayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export default function usePaidPlacement() {
  const [placement, setPlacement] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getDoc(doc(db, "paidPlacements", todayKey()))
      .then((snap) => {
        if (cancelled) return;
        if (snap.exists() && snap.data().status === "active") {
          setPlacement({ id: snap.id, ...snap.data() });
        } else {
          setPlacement(null); // no paid spot booked today — section just doesn't render
        }
      })
      .catch((err) => {
        console.error("usePaidPlacement error:", err);
        if (!cancelled) setPlacement(null);
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { placement, loading };
}